import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import watch from './attrs/watch'

export default {
    name: 'EventCheckout',
    computed,
    data,
    methods,
    watch
}
